import React from 'react';
import Label from "semantic-ui-react/dist/es/elements/Label/Label.js";
import { buildKeyFromStrings } from "../../../../utils/build-key-from-strings";
import { getFirstFourItems } from "../../../../utils/get-first-four-items";
import { IconCard } from "../../../elements/IconCard";
import { getTransportOptionLabel } from "./getTransportOptionLabel";
export var getTransportOptionsMarkup = function getTransportOptionsMarkup(transportOptions) {
  return React.createElement(Label.Group, null, getFirstFourItems(transportOptions).map(function (_ref, index) {
    var distance = _ref.distance,
        iconName = _ref.iconName,
        label = _ref.label;
    return React.createElement(IconCard, {
      isFilled: true,
      key: buildKeyFromStrings(label, index),
      label: getTransportOptionLabel(distance, label),
      name: iconName
    });
  }));
};